import { render, staticRenderFns } from "./RatePmsOverView.vue?vue&type=template&id=2664a280"
import script from "./RatePmsOverView.vue?vue&type=script&lang=js"
export * from "./RatePmsOverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports